import { h, render } from 'preact';
import CookieBanner from './CookieBanner';

export default class CookieBannerContainer {
    constructor( container ) {
        this.container = container;
        const data = {
            linkTo: JSON.parse(this.container.dataset.linkTo),
            gmtId: this.container.dataset.gmtId
        }

        render( (
            <CookieBanner data={data} />
        ), this.container)
    }

    // Called when the widget is removed from the page
    destroy() {
        render( null, this.container );
    }
};